import * as z from 'zod';

export const ConfirmForgotPasswordSchema = z.object({
  email: z.string({ required_error: 'email_required' }).email({ message: 'email_invalid' }),
  code: z.string({ required_error: 'code_required' }),
  password: z.string({ required_error: 'password_required' }),
});

export type IConfirmForgotPasswordSchema = z.infer<typeof ConfirmForgotPasswordSchema>;
